import { FCX } from '@models';
import { useTableContext } from './TableContext';
import TableCell from './TableCell';
import cn from 'classnames';

const TableRow: FCX<{
    index: number;
    onClick?: (index: number) => void;
    isActive?: boolean;
}> = ({
    index,
    style,
    className,
    children,
    onClick,
    isActive,
}) => {
    const { config } = useTableContext();
    return (
        <div
            style={style}
            className={cn(
                "TableRow",
                className,
                isActive && "is-active",
                onClick !== undefined && "is-clickable",
            )}
            onClick={onClick ? () => onClick(index) : undefined}
        >
            {config.map(item => {
                const {
                    Value,
                    styles,
                    getAttrs,
                    key,
                } = item;
                return (
                    <TableCell
                        key={key}
                        style={styles?.cell}
                        attrs={getAttrs ? getAttrs(index) : undefined}
                    >
                        <Value index={index}/>
                    </TableCell>
                );
            })}
            {children}
        </div>
    );
}

export default TableRow;